import React from 'react';
import Chart from 'react-apexcharts';

const DonutChart = ({ title, labels, series, colors, height = 350 }) => {
    const options = {
        chart: {
            type: 'donut',
        },
        labels: labels || [],
        colors: colors || ['#3B82F6', '#10B981', '#F59E0B', '#EF4444'],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return Math.round(val) + "%"
            }
        }
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow">
            {title && <h3 className="text-lg font-medium text-gray-900 mb-4">{title}</h3>}
            <Chart
                options={options}
                series={series || []}
                type="donut"
                height={height}
            />
        </div>
    );
};

export default DonutChart;